/**
 * AUTO-GENERATED by scripts/generate-module-manifest.ts
 * DO NOT EDIT THIS FILE BY HAND.
 *
 * Run `pnpm gen:modules` after adding, removing, or renaming a
 * module with `services/public-api.ts`.
 */

/* eslint-disable */
// prettier-ignore-start

export type GeneratedPublicApiNamespace = Record<string, (...args: unknown[]) => unknown>

export interface GeneratedCrossModuleClient {
  accounting: GeneratedPublicApiNamespace
  ai: GeneratedPublicApiNamespace
  carRental: GeneratedPublicApiNamespace
  chat: GeneratedPublicApiNamespace
  crm: GeneratedPublicApiNamespace
  fleet: GeneratedPublicApiNamespace
  inventory: GeneratedPublicApiNamespace
  purchase: GeneratedPublicApiNamespace
  sales: GeneratedPublicApiNamespace
  workflow: GeneratedPublicApiNamespace
}

export interface GeneratedCrossModuleEnv {
  MOD_ACCOUNTING?: unknown
  MOD_AI?: unknown
  MOD_CAR_RENTAL?: unknown
  MOD_CHAT?: unknown
  MOD_CRM?: unknown
  MOD_FLEET?: unknown
  MOD_INVENTORY?: unknown
  MOD_PURCHASE?: unknown
  MOD_SALES?: unknown
  MOD_WORKFLOW?: unknown
  [key: string]: unknown
}

export interface GeneratedModuleTransportConfig<T extends object> {
  bindingKey: keyof GeneratedCrossModuleEnv
  loadBundled: () => Promise<T> | T
}

export const generatedModuleTransports = {
  accounting: {
    bindingKey: 'MOD_ACCOUNTING',
    loadBundled: () =>
      import('../../../../modules/accounting/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  ai: {
    bindingKey: 'MOD_AI',
    loadBundled: () =>
      import('../../../../modules/ai/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  carRental: {
    bindingKey: 'MOD_CAR_RENTAL',
    loadBundled: () =>
      import('../../../../modules/car-rental/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  chat: {
    bindingKey: 'MOD_CHAT',
    loadBundled: () =>
      import('../../../../modules/chat/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  crm: {
    bindingKey: 'MOD_CRM',
    loadBundled: () =>
      import('../../../../modules/crm/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  fleet: {
    bindingKey: 'MOD_FLEET',
    loadBundled: () =>
      import('../../../../modules/fleet/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  inventory: {
    bindingKey: 'MOD_INVENTORY',
    loadBundled: () =>
      import('../../../../modules/inventory/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  purchase: {
    bindingKey: 'MOD_PURCHASE',
    loadBundled: () =>
      import('../../../../modules/purchase/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  sales: {
    bindingKey: 'MOD_SALES',
    loadBundled: () =>
      import('../../../../modules/sales/services/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
  workflow: {
    bindingKey: 'MOD_WORKFLOW',
    loadBundled: () =>
      import('../../../../modules/core/services/workflow/public-api') as unknown as Promise<GeneratedPublicApiNamespace>,
  },
} satisfies {
  [K in keyof GeneratedCrossModuleClient]: GeneratedModuleTransportConfig<GeneratedCrossModuleClient[K]>
}

// prettier-ignore-end
